<template>
  <div id="wrapperVisualizacoesAvisos">
    <h5 class="w-100 px-3 titulo-mobile d-flex justify-content-between align-items-center flex-wrap">
      <b-button variant="secondary" @click="verRelatorio" class="" :disabled="isBusy">
        <b-spinner small v-if="isBusy" class="mr-2" />
        <font-awesome-icon v-else icon="file-pdf" class="mr-3" />
        Relatório
      </b-button>
      <busca-tabela @busca="arg => visualizacoesFilter = arg" />
    </h5>
    <b-table
      :fields="visualizacoesFields"
      :filter="visualizacoesFilter"
      :filter-included-fields="visualizacoesFilterOn"
      hover
      no-border-collapse
      :items="visualizacoes"
      :sort-desc="true"
      striped
      small
      show-empty
      stacked="lg"
      responsive
      :per-page="visualizacoesPerPage"
      :current-page="visualizacoesCurrentPage"
    >
      <template #empty>
        <span>Não foram encontrados dados.</span>
      </template>
      <template #emptyfiltered>
        <span>Não foram encontrados dados.</span>
      </template>
      <template #table-busy>
        <div class="text-center text-dark">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="loading-text">Carregando...</strong>
        </div>
      </template>
    </b-table>
    <table-pagination v-if="visualizacoes.length > visualizacoesPerPage" :total-rows="visualizacoes.length"
      :per-page="visualizacoesPerPage" @pageChange="visualizacoesPageChange" />
    <ModalPdf v-if="!isBusy && pdfObj" titulo="Visualizações do aviso" :pdfData="pdfObj" :filename="filename" />
  </div>
</template>

<script lang="ts">
/* import messagesService from "@/services/messagesService"; */
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import { UtilsTS } from '@/utilsts';
import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { fieldsVisualizacoes } from "@/types/avisos/fields-visualizacoes";
import { PropType } from "vue";
import { VisualizacaoAviso } from "@/types/avisos/visualizacao-aviso";
import reportService from '@/services/reportService'
import { FiltrosGestao } from "@/types/relatorios/filtros-gestao";
import BuscaTabela from "@/components/shared/BuscaTabela.vue";
import ModalPdf from "../ModalPdf.vue";

const CompProps = Vue.extend({
  name: 'AbaVisualizacoesAviso',
  components: {
    BuscaTabela,
    ModalPdf,
    TablePagination,
  },
  props: {
    idAviso: {
      type: String,
      required: true
    },
    visualizacoes: {
      type: Array as PropType<VisualizacaoAviso[]>,
      default: () => []
    }
  }
})
@Component
export default class AbaVisualizacoesAviso extends mixins(UtilsTS, CompProps) {
  pdfObj: any = ''
  isBusy = false
  visualizacoesFields = fieldsVisualizacoes
  visualizacoesFilter = ''
  visualizacoesFilterOn = ["nomeUsuario", "unidadeGestora"]
  visualizacoesPerPage = 10
  visualizacoesCurrentPage = 1

  visualizacoesPageChange(value) {
    this.visualizacoesCurrentPage = value;
  }

  get filename() {
    return `Visualizações do Aviso ${this.idAviso}-${new Date().toLocaleTimeString()}.pdf`
  }
  async verRelatorio() {
    try {
      this.pdfObj = '';
      this.isBusy = true;
      const filtroGestao = new FiltrosGestao()
      filtroGestao.idaviso = +this.idAviso
      const response = await reportService.getRelatorioGestao('AvisosSagresVisualizacoes', filtroGestao)
      const blob = this.base64ToPdf(response.ArquivoPdf ?? '')
      const objectUrl = URL.createObjectURL(blob)
      this.pdfObj = objectUrl;
    } catch (e: any) {
      this.tratarError(e)
    } finally {
      this.isBusy = false;
    }
  }
}
</script>

<style scoped></style>
